import React, { useState } from "react";
import Layout from "@/components/Layout";
import UpperTab from "@/components/UpperTab";

export default function CasinoReport() {
  const [loading, setLoading] = useState(false);

  // Sample data based on the image description
  // Grouped by date
  const [transferData, setTransferData] = useState([
    {
      date: "21/12/2025",
      transactions: [
        {
          id: 1,
          time: "01:00:19 AM",
          payerPayee: "salludon",
          amount: 50.0,
        },
      ],
    },
  ]);

  const handleDownloadCSV = () => {
    console.log("Downloading CSV...");
    // TODO: Implement CSV download
  };

  const handleRefresh = async () => {
    setLoading(true);
    try {
      // TODO: Add API call to refresh transfer statement data
      console.log("Refreshing transfer statement data...");
      await new Promise((resolve) => setTimeout(resolve, 500));
    } catch (error) {
      console.error("Error refreshing data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
 
      <div className="p-4 w-full mx-auto bg-[#171b36] min-h-screen">
        {/* Header Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
          className="shadow-sm px-4 pt-4"
        >
          <div className="flex justify-between items-start mb-2">
            <div
              style={{ color: "#cae0e8", fontSize: "24px" }}
              className="font-semibold"
            >
              Transfer Statement
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleRefresh}
                disabled={loading}
                className="bg-[#11374a] hover:bg-[#1a4f66] text-white font-bold text-[14px] px-3 py-2 transition-colors disabled:opacity-50"
              >
                {loading ? "Refreshing..." : "Refresh"}
              </button>
              <button
                onClick={handleDownloadCSV}
                className="bg-[#333d79ff] hover:bg-[#1a4f66] text-white font-bold text-[14px] px-3 py-2 transition-colors"
              >
                Download CSV
              </button>
            </div>
          </div>
          {/* <div className="w-full h-px bg-white mb-2"></div> */}
        </div>

        {/* Table Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)", marginTop: "-10px" }}
          className="shadow-sm px-4 py-2"
        >
          <div className="overflow-x-auto">
            <table className="table table-striped w-full text-sm">
              <thead style={{backgroundColor: "rgba(245,245,245,0.05)", border:'0', outline:'0', borderBottom: '1px solid transparent'}} >
                <tr>
                  <th style={{borderBottom: '1px solid transparent'}} className="text-left px-2 py-1 text-white font-bold text-[14px]">
                    Date
                  </th>
                  <th style={{borderBottom: '1px solid transparent'}} className="text-left px-2 py-1 text-white font-bold text-[14px]">
                    Payer/Payee
                  </th>
                  <th style={{borderBottom: '1px solid transparent'}} className="text-right px-2 py-1 text-white font-bold text-[14px]">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {transferData.length === 0 ? (
                  <tr>
                    <td style={{borderBottom: '1px solid transparent'}} colSpan="3" className="px-2 py-8 text-center text-gray-400">
                      There are no records to show
                    </td>
                  </tr>
                ) : (
                  transferData.map((dateGroup, dateIndex) => (
                    <React.Fragment key={dateIndex}>
                      {/* Date Row */}
                      <tr>
                        <td    style={{ backgroundColor: "rgba(245, 245, 245, 0.4)", borderBottom: '1px solid transparent' }} colSpan="3" className="transferDate px-2 py-1">
                          <span className="text-white font-bold">{dateGroup.date}</span>
                        </td>
                      </tr>
                      {/* Transaction Rows */}
                      {dateGroup.transactions.map((transaction, transIndex) => (
                        <tr style={{borderBottom: '1px solid transparent'}} key={transaction.id}>
                          <td   style={{ backgroundColor: "rgba(0, 0, 0, 0.4)",width: '20%', borderBottom: '1px solid transparent' }} className="transferTime px-2 py-1">
                            <span className="text-white text-[13px]">{transaction.time}</span>
                          </td>
                          <td   style={{ backgroundColor: "rgba(0, 0, 0, 0.4)", borderBottom: '1px solid transparent' }} className="px-2 py-1">
                            <span className="text-white font-medium">{transaction.payerPayee}</span>
                          </td>
                          <td  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)", borderBottom: '1px solid transparent' }} className="text-right px-2 py-1">
                            <span className="positive positive text-green-500 font-bold">
                              {transaction.amount.toFixed(2)}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}

